module.exports = __webpack_public_path__ + "img/google.b038e6c6.png";